import { render, staticRenderFns } from "./HomeSlider.vue?vue&type=template&id=40dcd874&scoped=true&"
import script from "./HomeSlider.vue?vue&type=script&lang=js&"
export * from "./HomeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dcd874",
  null
  
)

export default component.exports